module.exports = __webpack_public_path__ + "img/sv18.8b13ce70.svg";